import s from "./index49.js";
import f from "./index73.js";
const p = f.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(n, r, o, e, t, u, c) {
      if (typeof document > "u")
        return;
      const i = [`${n}=${encodeURIComponent(r)}`];
      s.isNumber(o) && i.push(`expires=${new Date(o).toUTCString()}`), s.isString(e) && i.push(`path=${e}`), s.isString(t) && i.push(`domain=${t}`), u === !0 && i.push("secure"), s.isString(c) && i.push(`SameSite=${c}`), document.cookie = i.join("; ");
    },
    read(n) {
      if (typeof document > "u")
        return null;
      const r = document.cookie.split(";");
      for (let o = 0; o < r.length; o++) {
        const e = r[o].replace(/^\s+/, ""), t = e.indexOf("=");
        if (t !== -1 && e.slice(0, t) === n)
          try {
            return decodeURIComponent(e.slice(t + 1));
          } catch {
            return e.slice(t + 1);
          }
      }
      return null;
    },
    remove(n) {
      this.write(n, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
export {
  p as default
};
